import { useNavigate } from 'react-router-dom';
import { SignalSlashIcon } from '@heroicons/react/24/outline';

export default function OfflinePage() {
  const navigate = useNavigate();

  return (
    <div className="h-full flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-md text-center">
        <div className="mb-6">
          <SignalSlashIcon className="mx-auto h-16 w-16 text-gray-400" />
        </div>
        <h1 className="text-2xl font-semibold text-gray-700 mb-4">You're Offline</h1>
        <p className="text-gray-600 mb-8">
          It looks like you're not connected to the internet. You can still access your downloaded assessments and data.
        </p>
        <button
          onClick={() => navigate('/')}
          className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors"
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}
